import React from 'react';

function LoadingSpinner() {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>Translating document...</p>
    </div>
  );
}

export default LoadingSpinner;
